import { isEqual } from "lodash";
import { useForm } from "react-hook-form";

import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../constants";
import { useShiftDiscoveryUserFiltersContext } from "../useUserFiltersContext";
import { type FiltersFormValues } from "./types";

function getDefaultFormValues(
  defaultValues: Partial<FiltersFormValues> & Pick<FiltersFormValues, "distance">
): FiltersFormValues {
  return {
    shiftTimeSlots: [],
    licenses: [],
    includeWindowedOutShifts: false,
    includedStates: [],
    ...defaultValues,
  };
}

export function useFiltersForm() {
  const {
    setFilters,
    shiftTimeSlots,
    distance,
    licenses,
    includeWindowedOutShifts,
    includedStates,
  } = useShiftDiscoveryUserFiltersContext();

  const defaultFormValues = getDefaultFormValues({ distance });

  const form = useForm<FiltersFormValues>({
    defaultValues: {
      ...defaultFormValues,
      licenses,
      shiftTimeSlots,
      includeWindowedOutShifts,
      includedStates,
    },
  });

  const formValues = form.watch();
  const changedFiltersCount = Object.entries(formValues).filter(
    ([key, value]) => !isEqual(value, defaultFormValues[key as keyof FiltersFormValues])
  ).length;

  const resetFilters = () => {
    const resetValues = getDefaultFormValues({ distance: DEFAULT_DISTANCE_IN_MILES_FILTER });
    form.reset(resetValues);
    setFilters(resetValues);
  };

  const cancelFilters = () => {
    form.reset(); // resets to values when form was initialized
  };

  const submitFilters = () => {
    setFilters(formValues);
  };

  return {
    form,
    changedFiltersCount,
    resetFilters,
    cancelFilters,
    submitFilters,
  };
}
